import React from 'react';
import { Box } from '@mui/material';
import { onboardingHints, routes } from '../../../constants';
import { OnboardingHint } from '../../OnboardingHint';
import { SectionHeader } from './SectionHeader';
import MenuItem from './MenuItem';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../reducers/user.selectors';

const SideNavbarCourseSection = ({ isCollapsed }: {isCollapsed: boolean}) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);

  const courseCatalogButton = () => {
    const courseCatalogMenuItem = (
      <MenuItem
        icon='teacherNav'
        label='Course Catalog'
        to={routes.courseCatalog.root}
        isCollapsed={isCollapsed}
      />  
    );

    if (user?.isDocumentUser) {
      return (
        <OnboardingHint
          id={onboardingHints.courseOnboardingHint}
          title={t('Over 500 courses')}
          description={t('You can now find practical courses for your further training under meineFortbildung.')}
          placement='right'
          isNew={true}
          disablePortal={false}
          maxWidth={380}
          offset={{ x: 12 }}
        >
          <Box>
            {courseCatalogMenuItem}
          </Box>
        </OnboardingHint>
      );
    } else {
      return courseCatalogMenuItem;
    }
  };
    
  return <>
    <SectionHeader isCollapsed={isCollapsed} title={t('Shulflix')} />
    {courseCatalogButton()}
    <MenuItem icon='folderFavourite' label='My Courses' to={routes.myCourses.root} isCollapsed={isCollapsed} />
    <MenuItem icon='medal' label='Certificate' to={routes.myCertificates.root} isCollapsed={isCollapsed} />   
  </>;
};

export default SideNavbarCourseSection;
